import React, { FC } from 'react';

import {
	NOT_SYNCED_YET_POPUP_TEXT,
	NOT_SYNCED_YET_POPUP_TITLE,
	NOT_SYNCED_YET_STATE_KEY
} from 'src/apps/wfa/helpers/WfaDashboardConsts';
import { ReportNotFoundPopup } from 'src/common/components/report-not-found-popup/ReportNotFoundPopup';

export const WfaSessionNotSyncedYetPopup: FC = () => {
	return (
		<ReportNotFoundPopup
			title={NOT_SYNCED_YET_POPUP_TITLE}
			text={NOT_SYNCED_YET_POPUP_TEXT}
			stateKey={NOT_SYNCED_YET_STATE_KEY}
		/>
	);
};
